import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import OrderCard from '../order/OrderCard'
import {UpdateProfileRequest, GetProfileRequest, GetBankRequest, UpdateBankRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';



const Profile = () => {
    const fetchReducer = useSelector((state) => state.FetchDataReducer)
    var profiledata = fetchReducer?.profileResponse?.data
    const [activeTab, setActiveTab] = useState("tabs-one");
    const [profilefile, setprofilefile] = useState("");
    const [profilePreviewImage, setprofilePreviewImage] = useState("");
    const [fname, setfname] = useState("");
    const [lname, setlname] = useState("");
    const [bankfname, setbankfname] = useState("");
    const [banklname, setbanklname] = useState("");
    const [ach, setach] = useState("");
    const [bank, setbank] = useState("");
    const [account, setaccount] = useState("");
    const [confirmaccount, setconfirmaccount] = useState("");
    const [address, setaddress] = useState("");
    const [zipcode, setzipcode] = useState("");
    const [email, setemail] = useState("");
    const [drivinglicencefile, setdrivinglicencefile] = useState("");
    const [drivinglicencepreview, setdrivinglicencepreview] = useState("");
    
    const dispatch = useDispatch()

    useEffect(()=>{
      dispatch(GetProfileRequest())
      dispatch(GetBankRequest())
    },[])

    useEffect(()=>{
      setfname(profiledata?.first_name)
      setlname(profiledata?.last_name)
      setaddress(profiledata?.profile?.address)
      setzipcode(profiledata?.profile?.zipcode)
      setemail(profiledata?.email)
      setdrivinglicencepreview(profiledata?.driving_license)
      setprofilePreviewImage(profiledata?.profile_picture)

    },[fetchReducer?.profileResponse])
    
    console.log(fetchReducer)

    useEffect(()=>{

      var bankdata = fetchReducer?.GetBankResponse?.data

      setbankfname(bankdata?.first_name)
      setbanklname(bankdata?.last_name)
      setach(bankdata?.ach)
      setbank(bankdata?.bank)
      setaccount(bankdata?.account)
      setconfirmaccount(bankdata?.account)


    },[fetchReducer?.GetBankResponse])

    const HandleImage = (e) => {
        var file = e.target.files[0];
        setprofilefile(file);
        var reader = new FileReader();
        //var url = reader.readAsDataURL(file);
        reader.onloadend = function (e) {
          const fsize = file.size;
          const fileSize = Math.round(fsize / 1024);
          if (fileSize >= 800) {
            toast.error('file size is too large');
          } else {
            setprofilePreviewImage(reader.result)
            // var editImg = document.getElementById("editImg");
            // editImg.src = reader.result;
          }
        };
        reader.readAsDataURL(file);
      };

      const HandledrivingImage = (e) => {
        var file = e.target.files[0];
        setdrivinglicencefile(file);
        var reader = new FileReader();
        //var url = reader.readAsDataURL(file);
        reader.onloadend = function (e) {
          const fsize = file.size;
          const fileSize = Math.round(fsize / 1024);
          if (fileSize >= 800) {
            toast.error('file size is too large');
          } else {
            setdrivinglicencepreview(reader.result)
            // var editImg = document.getElementById("editImg");
            // editImg.src = reader.result;
          }
        };
        reader.readAsDataURL(file);
      };

      const Handleprofile = () =>{
        setActiveTab("tabs-one")
    }
    const Handlebank = () =>{
        setActiveTab("tabs-two")
    }


      const UpdateHandle = ()=>{

        const FormData = require('form-data');
        let data = new FormData();
        data.append('address', address);
        data.append('zipcode', zipcode);
        {drivinglicencefile !== '' &&
        data.append('driving_licence', drivinglicencefile);
        }
        {profilefile !== '' &&
        data.append('image', profilefile);
        }
        dispatch(UpdateProfileRequest(data))  


      }


      const UpdateBank = ()=>{
        if(bankfname == ''){
          toast.error('First name is required');
        } else if (banklname == ''){
          toast.error('Last name is required');
        } else if (ach == ''){
          toast.error('ACH is required');
        } else if (bank == ''){
          toast.error('Bank name is required');
        }  else if (account == ''){
          toast.error('A/C no is required');
        } else if (account !== confirmaccount){
          toast.error('Confirm account does not match');
        }  else {

          let obj ={
            "first_name": bankfname,
            "last_name": banklname,        
            "ach": ach,        
            "bank":bank,        
            "account":account,      
            "account_confirmation":confirmaccount     
        }

          dispatch(UpdateBankRequest(obj));
        }
      }


  return (
    <>
    <AfterLoginTopbar
    title={`Welcome ${profiledata?.first_name}`}
    acttion="menu"
    />
     <Loader visible={fetchReducer.isloading} />
    <div className='comon-body' style={{background:'transparent'}}>
    <div className='custom-tabs mb-5'>
        <ul>
            <li><button className={activeTab === "tabs-one" ? "active" : ""} onClick={Handleprofile}>Profile</button></li>
            <li><button className={activeTab === "tabs-two" ? "active" : ""} onClick={Handlebank}>Bank Details</button></li>
        </ul>
    </div>
    {activeTab === "tabs-one" && 
                <div className='update-profile'>
                <div className='profile-pic'>
                    <img src={profilePreviewImage} alt="profile" id="editImg" />
                    <div className='file-upload'>
                        <input type="file" accept="image/*" onChange={HandleImage} />
                        <i className="fa-solid fa-camera"></i>
                    </div>
                  </div>
                  <div className='form-group'>
                    <label>First Name</label>
                    <input type='text' placeholder='First Name' className='form-control'
                    value={fname}
                    onChange={(e)=>setfname(e.target.value)}
                    readOnly
                    />
                  </div>
                  <div className='form-group'>
                    <label>Last Name</label>
                    <input type='text' placeholder='Last Name' className='form-control'
                    value={lname}
                    onChange={(e)=>setlname(e.target.value)}
                    readOnly
                    />
                  </div>
                  <div className='form-group'>
                    <label>Address</label>
                    <input type='text' placeholder='Address' className='form-control'
                    value={address}
                    onChange={(e)=>setaddress(e.target.value)}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Zipcode</label>
                    <input type='text' placeholder='Zipcode' className='form-control'
                    maxLength="6"
                    minLength="6"
                    onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                    value={zipcode}
                    onChange={(e)=>setzipcode(e.target.value)}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Email</label>
                    <input type='text' placeholder='Email' className='form-control'
                    readOnly
                    value={email}
                    onChange={(e)=>setemail(e.target.value)}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Driving Licence</label>
                    <img src={drivinglicencepreview} className='w-100'/>
                  </div>
                  <div className='form-group'>
                    <div className='upload-doc'>
                        <input type='file' className='form-control' onChange={HandledrivingImage}  />
                        <span>Upload driving licence</span>
                    </div>
                </div>
                <div className='form-group'>
                    <button className='themeBtn' onClick={UpdateHandle}>Update Profile</button>
                </div>
                </div>
            }

{activeTab === "tabs-two" && 
<>
          <div className='form-group'>
          <label>First Name</label>
          <input type='text' placeholder='First Name' className='form-control'
          value={bankfname}
          onChange={(e)=>setbankfname(e.target.value)}

          />
          </div>
       <div className='form-group'>
          <label>Last Name</label>
          <input type='text' placeholder='Last Name' className='form-control'
          value={banklname}
          onChange={(e)=>setbanklname(e.target.value)}
   
          />
        </div>
        <div className='form-group'>
          <label>ACH</label>
          <input type='text' placeholder='ACH' className='form-control'
          value={ach}
          onChange={(e)=>setach(e.target.value)}
      
          />
        </div>
        <div className='form-group'>
          <label>Bank Name</label>
          <input type='text' placeholder='Bank Name' className='form-control'
          value={bank}
          onChange={(e)=>setbank(e.target.value)}
      
          />
        </div>
        <div className='form-group'>
          <label>A/C</label>
          <input type='text' placeholder='Account No' className='form-control'
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          value={account}
          onChange={(e)=>setaccount(e.target.value)}
      
          />
        </div>
        <div className='form-group'>
          <label>Confirm A/C</label>
          <input type='text' placeholder='Confirm Account No' className='form-control'
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          value={confirmaccount}
          onChange={(e)=>setconfirmaccount(e.target.value)}
      
          />
        </div>
        <div className='form-group'>
            <button className='themeBtn' onClick={UpdateBank}>Update</button>
          </div>
        </>
          }
     
    </div>
  </>
  )
}

export default Profile